import { useState, useEffect } from 'react';
const Mounted = _ref => {
  let {
    children
  } = _ref;
  const {
    0: mounted,
    1: setMounted
  } = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);
  if (mounted) {
    return children;
  } else {
    return null;
  }
};
export default Mounted;